<h2 fxLayoutAlign="center center"
    mat-dialog-title
    translate="{{data.title}}"></h2>

<mat-dialog-content>
  <div [innerHTML]="data.text"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button
          cdkFocusInitial
          [mat-dialog-close]="true"
          translate="shared.labels.ok"></button>
  <button mat-button
          [mat-dialog-close]="false"
          translate="shared.labels.cancel"></button>
</mat-dialog-actions>
